import { Typography } from "@mui/material";

export default function NoReviews() {
  return (
    <Typography
      sx={{
        marginTop: 1,
        marginBottom: 2,
      }}
    >
      No reviews found
    </Typography>
  );
}
